import { SharedTable } from '@components';
import { UnavailabilityHook } from '@models';
import { Table } from 'antd';
import React from 'react';
import { Columns } from './UnavailabilityTable.columns';

interface TableProps {
  unavailabilityHook: UnavailabilityHook;
  handleDelete: (id: string) => Promise<void>;
}

const UnavailabilityTable: React.FC<TableProps> = ({ unavailabilityHook, handleDelete }) => {
  return (
    <>
      <SharedTable
        {...unavailabilityHook}
        columns={Columns({ handleDelete })}
        summary={() => (
          <Table.Summary fixed="top">
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} />
              <Table.Summary.Cell index={1} />
              <Table.Summary.Cell index={2} />
              <Table.Summary.Cell index={3} />
            </Table.Summary.Row>
          </Table.Summary>
        )}
      />
    </>
  );
};

export default UnavailabilityTable;
